import React from 'react'

import { Box, Checkbox, RadioButton } from '@factorialco/deprecated-design-system'

import { Element } from 'modules/forms/lib/Element'

interface OptionElementPreviewProps {
  element: Element
  isSingleChoice: boolean
  disabled?: boolean
  showCorrectAnswers?: boolean
}

export const OptionElementPreview: React.FC<OptionElementPreviewProps> = ({
  element,
  isSingleChoice,
  disabled,
  showCorrectAnswers = false,
}) => {
  const Component = isSingleChoice ? RadioButton : Checkbox
  const userAnswer = element.answer

  return (
    <>
      {element.options.map((option, index) => {
        const optionValue = option.id || `${element.uuid}-${index}`

        // Show correct answers if requested, otherwise show user's selection
        const isChecked = showCorrectAnswers
          ? option.isCorrect
          : userAnswer?.options?.includes(option.id || '') || false

        return (
          <Box key={optionValue} borderRadius={{ all: 'abs012' }} padding="s12">
            <Component
              size="small"
              value={optionValue}
              label={option.label}
              disabled={disabled}
              checked={isChecked}
              onChange={() => {}}
            />
          </Box>
        )
      })}
    </>
  )
}
